import { defineMessages } from 'react-intl';

export default defineMessages({
    removeInfo: {
        id: 'quoteandbind.PELLinedirectives.templates.Remove Storage Tank',
        defaultMessage: 'Remove Property',
    },
    removeInfoDesc: {
        id: 'quoteandbind.PELLinedirectives.templates.StorageTankInformation',
        defaultMessage: 'Are you sure you want to remove this Storage Tank from the list?',
    },
    documentUploadFailed: {
        id: 'policy.common.component.documents.Document upload failed',
        defaultMessage: 'Document upload failed'
    },
    documentCannotUploaded: {
        id: 'policy.common.component.documents.Failed to upload file, either you do not have permission or a file exists with the same name.',
        defaultMessage: 'Failed to upload file, either you do not have permission or a file exists with the same name.'
    },
    documentUploadSuccess: {
        id: 'quoteandbind.PELLinedirectives.templates.StorageTankInformation.success',
        defaultMessage: 'Success'
    },
    documentUploaded: {
        id: 'quoteandbind.PELLinedirectives.templates.StorageTankInformation.Document uploaded successfully.',
        defaultMessage: 'Document uploaded successfully.'
    },
    storageTankInformation: {
        id: 'quoteandbind.PELLinedirectives.templates.StorageTankInformation.Storage Tank Information',
        defaultMessage: 'Storage Tank Information'
    }
});